var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52865 5.80469C7.28457 5.56061 7.26951 5.17461 7.48308 4.91276L7.52865 4.86198L10.1953 2.19531L10.2461 2.14974C10.5079 1.93617 10.8939 1.95123 11.138 2.19531L13.8047 4.86198C14.065 5.12233 14.065 5.54434 13.8047 5.80469C13.5443 6.06504 13.1223 6.06504 12.862 5.80469L11.3333 4.27604L11.3333 13.3333C11.3333 13.7015 11.0349 14 10.6667 14C10.2985 14 10 13.7015 10 13.3333L10 4.27604L8.47136 5.80469L8.42058 5.85026C8.15873 6.06383 7.77273 6.04876 7.52865 5.80469Z",
    fill: "#405368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19516 10.1953C1.95108 10.4394 1.93602 10.8254 2.14958 11.0872L2.19516 11.138L4.86182 13.8047L4.9126 13.8503C5.17445 14.0638 5.56045 14.0488 5.80453 13.8047L8.4712 11.138C8.73155 10.8777 8.73155 10.4557 8.4712 10.1953C8.21085 9.93496 7.78884 9.93496 7.52849 10.1953L5.99984 11.724L5.99984 2.66667C5.99984 2.29848 5.70137 2 5.33318 2C4.96499 2 4.66651 2.29848 4.66651 2.66667L4.66651 11.724L3.13786 10.1953L3.08708 10.1497C2.82523 9.93617 2.43923 9.95124 2.19516 10.1953Z",
    fill: "#405368"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export default ForwardRef;